import React from "react";
import { CoRetrieveDocumentData } from "../../components/generic/CoRetrieveDocumentData";
import { ObjectPanelElaborationWrapper } from "../../components/coobjects/ObjectPanelElaborationWrapper";
import { DocumentNotValidError } from "../../components/generic/DocumentNotValidError";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";

export const NewObjectPage: React.FunctionComponent = () => {
  return (
    <ProtectedComponent
      userFunction={UserFunctionEnum.MENU_NEW_OBJECT}
      protectionType={true}
      errorComponent={<UnauthorizedError />}
    >
      <CoRetrieveDocumentData shouldFetchDocumentPart={true} shouldFetchDocumentPartMetadata={true}>
        {({ coObject, documentPart, documentPartMetadata }) =>
          coObject?.documentId ? (
            <ObjectPanelElaborationWrapper
              isEdit={false}
              coObject={coObject}
              documentPart={documentPart}
              documentPartMetadata={documentPartMetadata}
            />
          ) : (
            <DocumentNotValidError />
          )
        }
      </CoRetrieveDocumentData>
    </ProtectedComponent>
  );
};
